module.exports = __webpack_public_path__ + "static/img/title4.c99b0c8f.png";